var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"list-header",attrs:{"type":"flex","align":_vm.align,"gutter":_vm.gutter}},_vm._l((_vm.config),function(col,index){return _c('Col',{key:index,attrs:{"lg":col.lg}},[_c('span',[_vm._v(_vm._s(col.prop))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }